__turbopack_context__.v({
  "PopularProducts": "PopularProducts-module__yReeCa__PopularProducts",
  "banner": "PopularProducts-module__yReeCa__banner",
  "contents": "PopularProducts-module__yReeCa__contents",
  "left": "PopularProducts-module__yReeCa__left",
  "products": "PopularProducts-module__yReeCa__products",
  "right": "PopularProducts-module__yReeCa__right",
});
